<template>
  <div id="landing" class="page">
    <div class="portfolio">
      <div class="infor">
        <div class="name">{{name}}</div>
        <div class="id">{{id}}</div>
      </div>
    </div>
    <div class="begin">
      <div class="left-button"></div>
      <div class="right-button"></div>
      <touch class="open" @tap="begin"></touch>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'page-landing',
    computed: {
      ...mapState({
        name: state => state.data.nick,
        id: state => state.data.login,
        reportExist: state => state.data.reportExist
      })
    },
    created () {
      this.$track.sendPageTrack('get_report')
    },
    methods: {
      begin () {
        this.$track.sendActionTrack('get_report', 'click_open_report')
        this.$router.replace(this.reportExist ? 'archives' : 'nodata')
        this.$emit('playOrPauseBgMusic')
      }
    }
  }
</script>


<style lang="scss">
  $portfolio: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/portfolio-PtlUwHTf.png';
  $open: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/open-Qhh3tgWj.png';
  $button: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/buttons-IFC4vhQj.png';

  #landing {
    & ~ .music {
      display: none;
    }
    .portfolio {
      @include bg-image-contain($portfolio);
      position: relative;
      height: 100%;
      background-position: 0 0;
      .infor {
        padding-top: 616px;
        padding-left: 286px;
      }
      .name,
      .id {
        @include text-ellipsis;
        font-family: Helvetica,Tahoma,Arial,'PingFang SC','Microsoft YaHei','Hiragino Sans GB',SimSun,Heiti,sans-serif;
        width: 280px;
        height: 60px;
        font-size: 36px;
        font-weight: bolder;
        color: $brown;
        line-height: 60px;
      }
      .id {
        margin-top: 40px;
      }
    }
    .begin {
      position: absolute;
      left: 50%;
      bottom: 100px;
      width: 353px;
      margin-left: -177px;
      .open {
        @include bg-image-cover($open);
        position: relative;
        z-index: 3;
        width: 353px;
        height: 125px;
        animation: heartbeat 0.75s infinite ease-in-out;
        animation-direction: alternate;
      }
      .left-button,
      .right-button {
        @include bg-image-cover($button);
        position: absolute;
        top: 22px;
        z-index: 1;
        width: 80px;
        height: 80px;
      }
      .left-button {
        left: -40px;
      }
      .right-button {
        right: -40px;
      }
    }
  }
  body[data-webp='support'] {
    #landing {
      .portfolio {
        background-image: url($portfolio + '?imageMogr2/format/webp');
      }
      .begin {
        .open {
          background-image: url($open + '?imageMogr2/format/webp');
        }
        .left-button,
        .right-button {
          background-image: url($button + '?imageMogr2/format/webp');
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Landing.vue